import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isArray from 'lodash/isArray';
import { ValidationService } from 'shared/services';
import { Button } from 'shared/components';
import { DATE_FORMATS } from 'shared/constants';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import './TimeInput.scss';

const isTimeAm = (data) => moment(data).hours() < 12;

const validateTime = (value, prevValue) => {
  switch (value.length) {
    case 1:
      return +value > 1 ? `0${value}:` : value;
    case 2:
      if (prevValue.length > value.length) {
        return value.slice(0, 1);
      }

      if (isNaN(+value)) {
        return value.slice(0, value.length - 1);
      }

      if (+value > 12) {
        return +value < 15 ? `0${value[0]}:${value[1]}` : `0${value[0]}:0${value[1]}`;
      }

      return `${value}:`;
    case 3:
      if (value.indexOf(':') !== 2) {
        return prevValue;
      }
      return value;
    case 4:
      if (value.indexOf(':') !== 2) {
        return prevValue;
      }
      return value.substr(value.length - 1) > 5
        ? `${value.slice(0, value.length - 1)}0${value[value.length - 1]}`
        : value;
    default:
      return value;
  }
};

class TimeInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onTypeError: '',
      time: props.dateTime ? moment(props.dateTime).format('hh:mm') : '',
      timeAm: props.dateTime ? isTimeAm(props.dateTime) : true,
      isValid: !!props.dateTime,
    };

    this.onChangeMask = this.onChangeMask.bind(this);
    this.toggleAmPm = this.toggleAmPm.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.disabled && !prevProps.disabled) {
      this.setState({
        time: '',
      });
    }
  }

  onChangeMask(e) {
    const { inputName } = this.props;
    let { value } = e.target;
    this.setState({
      onTypeError: '',
    });
    if (value.length === 2 && +value === 0) {
      this.setState({
        onTypeError: 'errors.invalidTimeFormat',
      });
      return;
    }
    if (value.length > 5 || !ValidationService.clock(value)) {
      return;
    }

    value = validateTime(value, this.state.time);

    let time = value.replace(':', '');
    const momentTime = moment(time, 'hmm');

    if (time.length === 4 && momentTime.isValid()) {
      time = momentTime.format('hh:mm');
      const dateTime = moment(`${time} ${this.state.timeAm ? 'AM' : 'PM'}`, ['h:mm A']).format(
        DATE_FORMATS.dateTimeZone
      );
      this.setState({
        isValid: true,
      });
      this.props.onChange(dateTime, inputName);
    } else {
      this.setState({
        isValid: false,
      });
      this.props.onChange('', inputName);
    }

    this.setState({
      time: value,
    });
  }

  toggleAmPm() {
    const { isValid } = this.state;
    if (isValid) {
      const time = moment(this.state.time.replace(':', ''), 'hmm');
      const dateTime = moment(
        `${moment(time).format('hh:mm')} ${!this.state.timeAm ? 'AM' : 'PM'}`,
        ['h:mm A']
      ).format(DATE_FORMATS.dateTimeZone);
      this.props.onChange(dateTime, this.props.inputName);
    }

    this.setState((prevState) => ({
      timeAm: !prevState.timeAm,
    }));
  }

  render() {
    const { time, onTypeError } = this.state;
    const { className, label, icon, inputName, error, disabled } = this.props;
    const timeError = (isArray(error) ? error[0] : error) || onTypeError;

    return (
      <div className={`${className} time-input-container`}>
        {label && (
          <label
            className={`${timeError ? 'label-error' : ''} w-100 pt-2 fw-bold`}
            htmlFor={inputName}>
            {icon && <i className={`fa ${icon}`} aria-hidden="true" />}
            {this.props.t(label)}
          </label>
        )}
        <div>
          <input
            className={`${timeError ? 'error' : ''} time-input`}
            type="text"
            id={inputName}
            placeholder="hh:mm"
            value={time}
            onChange={this.onChangeMask}
            disabled={disabled}
          />
          <div className="time-buttons-container d-inline-block ps-2">
            <Button
              type={this.state.timeAm ? 'btn-primary' : 'btn-outline'}
              className="w-50 m-0 btn-selector"
              text={this.props.t('common.labels.amTime')}
              onClick={this.toggleAmPm}
              disabled={disabled}
            />
            <Button
              type={!this.state.timeAm ? 'btn-primary' : 'btn-outline'}
              className="w-50 m-0 btn-selector"
              onClick={this.toggleAmPm}
              text={this.props.t('common.labels.pmTime')}
              disabled={disabled}
            />
          </div>
          {timeError && <span className="text-error font-size-12">{this.props.t(timeError)}</span>}
        </div>
      </div>
    );
  }
}

TimeInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

TimeInput.defaultProps = {
  className: '',
  disabled: false,
};

export default withTranslation()(TimeInput);
